webpackJsonp([230197332751855],{

/***/ 155:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _iphone = __webpack_require__(155);
	
	var _iphone2 = _interopRequireDefault(_iphone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Iphone = function Iphone(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "iphone-wrapper" },
	    _react2.default.createElement(
	      "div",
	      { className: "iphone" },
	      _react2.default.createElement("img", { src: _iphone2.default, className: "iphone-img", alt: "Iphone" }),
	      _react2.default.createElement(
	        "div",
	        { className: "iphone-content" },
	        children
	      )
	    )
	  );
	};
	
	exports.default = Iphone;
	module.exports = exports["default"];

/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-desktop-1.fb07c8aa.png";

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-desktop-2.f4c37f12.png";

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-desktop-3.1baa4b25.png";

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-mobile-1.0f6425a7.png";

/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-mobile-2.323b1d72.png";

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-mobile-3.350e19f1.png";

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/scrabblista-mobile-4.e3d31382.png";

/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Iphone = __webpack_require__(89);
	
	var _Iphone2 = _interopRequireDefault(_Iphone);
	
	var _Macbook = __webpack_require__(61);
	
	var _Macbook2 = _interopRequireDefault(_Macbook);
	
	var _Carousel = __webpack_require__(60);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _TechStack = __webpack_require__(62);
	
	var _TechStack2 = _interopRequireDefault(_TechStack);
	
	var _Socials = __webpack_require__(31);
	
	var _Socials2 = _interopRequireDefault(_Socials);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mobileImages = [{ src: __webpack_require__(625),
	  description: "Scrabblista - main view" }, { src: __webpack_require__(626),
	  description: "Scrabblista - search query entered" }, { src: __webpack_require__(627),
	  description: "Scrabblista - search results sorted by length" }, { src: __webpack_require__(628),
	  description: "Scrabblista - search results sorted by points" }];
	var desktopImages = [{ src: __webpack_require__(622),
	  description: "Scrabblista - main view" }, { src: __webpack_require__(623),
	  description: "Scrabblista - search query entered" }, { src: __webpack_require__(624),
	  description: "Scrabblista - search results" }];
	
	var ProjectScrabblista = function ProjectScrabblista() {
	  var technologies = ["Ruby on Rails", "Ruby", "JavaScript"];
	  return _react2.default.createElement(
	    'div',
	    { className: 'project-single' },
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Scrabblista'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'project-links' },
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'http://www.scrabblista.pl', target: '_blank' },
	          'Live version'
	        )
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          'a',
	          { href: 'https://github.com/tomegz/scrabblista', target: '_blank' },
	          'Source code'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'project-inner' },
	      _react2.default.createElement(
	        'div',
	        { className: 'project-media' },
	        _react2.default.createElement(
	          _Iphone2.default,
	          null,
	          _react2.default.createElement(_Carousel2.default, { images: mobileImages })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-description' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Project'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'In February 2017, after three months of learning web development from online tutorials and finishing couple of small projects I decided to create my first server app. Instead of going with Facebook/Twitter/Reddit clone, I decided to stand out and create a word finder for Scrabble. Little did I know, that effective search through over 2,700,000 scrabble-viable words (Polish dictionary), could be a complex task. After few failed attemps with optimizing SQL queries I decided to store whole dictionary in a ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://en.wikipedia.org/wiki/Trie', target: '_blank' },
	            'Trie'
	          ),
	          '. This choice of data structure along with ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://en.wikipedia.org/wiki/Depth-first_search', target: '_blank' },
	            'depth-first search algorithm'
	          ),
	          ' implementation let me cut down search time to an acceptable value. Besides searching for words, that can be made from a given hand, user is also able to sort the result by word length, or highest score. In the future, if time allows me to get back to this project, I will hopefully make it twice as fast, include English dictionary and add pagination for search results.'
	        ),
	        _react2.default.createElement(_TechStack2.default, { technologies: technologies })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-media-large' },
	        _react2.default.createElement(
	          _Macbook2.default,
	          null,
	          _react2.default.createElement(_Carousel2.default, { images: desktopImages })
	        )
	      )
	    ),
	    _react2.default.createElement(_Socials2.default, null)
	  );
	};
	
	exports.default = ProjectScrabblista;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-project-scrabblista-index-js-e40bbe425542c58723b7.js